import { useCallback, useEffect } from 'react';
import { DateTime } from 'luxon';
import { useFormContext, useWatch } from 'react-hook-form';
import { isEmpty } from 'lodash';
import { FieldObject } from '../openapi/atlantis';

const useFieldArrayValidation = (fieldArray: FieldObject) => {
  const { control, setError, clearErrors } = useFormContext();

  const watchValues = useWatch({ control, name: fieldArray.id! });

  const customFieldArrayValidation = useCallback(() => {
    if (!watchValues) {
      return;
    }

    const errors: string[] = [];

    for (const validation of fieldArray.validations || []) {
      if (validation.type === 'group') {
        //@ts-ignore
        const { type, effectiveValue } = validation.validation;
        //@ts-ignore

        if (type === 'maxDate') {
          const validDates = (watchValues || [])
            //@ts-ignore
            .map((value: any) => value[validation.fieldId])
            .filter((v: string) => DateTime.fromISO(v).isValid);

          if (!isEmpty(validDates)) {
            const isValidValues = validDates.some((date: string) => {
              const maxDate = DateTime.fromISO(effectiveValue);

              return DateTime.fromISO(date).diff(maxDate, 'days').days < 0;
            });

            if (!isValidValues) {
              //@ts-ignore
              errors.push(validation.message);
            }
          }
        }
      }
    }

    if (!isEmpty(errors)) {
      setError('fieldArrayErrors', { message: errors.join(', ') });
    } else {
      clearErrors('fieldArrayErrors');
    }
  }, [watchValues, fieldArray.validations, setError, clearErrors]);

  useEffect(() => {
    customFieldArrayValidation();
  }, [customFieldArrayValidation]);
};

export default useFieldArrayValidation;
